// extracted by mini-css-extract-plugin
export default {"wrapperClass":"sA4oqQHvNbL0NiVpoMNj"};